import React from 'react';
import { Alert, Typography } from '@mui/material';
import { PlayerCardLayout } from '../../components/PlayerCardLayout';
import { useT } from '../../localization/LocalizationProvider';

export function StoppedPage({ header, reason }) {
  const t = useT();
  return (
    <PlayerCardLayout header={header}>
      <Alert severity="warning">{t('Player.Stopped.Title')}</Alert>
      <Typography>{reason}</Typography>
    </PlayerCardLayout>
  );
}
